import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, mergeMap } from 'rxjs/operators';
import {
  SeriesItemLocator,
  ViewDataService,
  WaHelperService,
  WCupSeasonItem,
  WCupSeasonLocator,
  FiltersTypeEnum
} from 'world-archery-lib';
import { BaseService } from '../shared/base.service';
import { TextFilter, ComboStoreComponent } from 'src/app/common-page-components/stores/filters-store/filters-store';
import { HttpClient } from '@angular/common/http';
import { FiltersAbstractService } from 'src/app/common-page-components/classes/filters-abstract-service';
@Injectable({
  providedIn: 'root'
})
export class FiltersServiceService extends FiltersAbstractService {
  textFilter = new TextFilter('indoor-calendar-text-filter', undefined, undefined, 'search');
  yearCombo = new ComboStoreComponent('Year:', 'Year', 'indoorteamseriesyear',
    undefined, undefined, this.http, 'SERIES', [], [], true, 'year');
  filtersType: any = [
    this.textFilter.filterInfo,
    this.yearCombo.filterInfo

  ];
  constructor(
    private http: HttpClient,
    protected route:ActivatedRoute,
    
  ) {
    super();
    this.generateDefaultValues();
  }

  /**
   * Method for generate the default values.
   *
   * @memberof FiltersServiceService
   */
  generateDefaultValues() {    
    this.yearCombo.filterInfo.options.initial_state = true;
    this.yearCombo.requestData({ 'DisciplineId': 2, 'RBP': 'ALL' }, false).pipe(
      map(a => a.items),
      mergeMap(
        next => {
          let comboSeason = [];

          let index = next.findIndex(
            value => value.discipline === 2
          );
          comboSeason = next.filter(value => value.Year >= 2019 && value.Discipline === 2);
          let selected = comboSeason[index];
          if(this.route.snapshot.queryParams['year']){
            index = comboSeason.findIndex(value => value.Year.toString() === this.route.snapshot.queryParams['year']);
            if(index > -1){
              selected = comboSeason[index];
            }
          }else{     
            selected = WaHelperService.getComboSeasonItemByCurrentYear(comboSeason);
          }
          this.filtersType[1].options.options_subject.next(comboSeason);
          this.filtersType[1].options.options_selected_subject.next(selected);
          return of(next);
        }
      )).subscribe();
  }

  /**
   *
   * @inheritdoc
   * @returns {Observable<any>}
   * @memberof FiltersServiceService
   */
  getDataStreamWithFilters(): Observable<any> {
    return;
  }
}
